var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var getAttrName = function (prop) {
    var name = prop.replace(/^allowed/, '').replace(/([^s])s$/, '$1');
    return name.charAt(0).toLocaleLowerCase() + name.substr(1);
};
var getNestedValue = function (val, valAllowed) {
    if (!valAllowed)
        return;
    if (!valAllowed.length)
        return val;
    var res = valAllowed[0];
    valAllowed.some(function (standardVal) {
        if (val <= standardVal) {
            res = standardVal;
            return false;
        }
        return true;
    });
    return res;
};
// sort from largest to smallest
var sortTypesetConfig = function (config) {
    return config.sort(function (a, b) {
        if (typeof b !== 'number')
            return 0;
        return b - a;
    });
};
var formatAllowedValues = function (config) {
    var defaultValue;
    var values = false;
    if (config) {
        if (Array.isArray(config)) {
            values = sortTypesetConfig(config.map(function (val) {
                if (val instanceof Object) {
                    if (val.default)
                        defaultValue = val.value;
                    return val.value;
                }
                return val;
            }));
        }
        else if (config.default) {
            defaultValue = config.value;
            values = [];
        }
    }
    return { values: values, defaultValue: defaultValue };
};
// format the `allowedValues` config
var getFormatAttrsByValue = function (allowedValues, attrName) {
    var _a = formatAllowedValues(allowedValues), values = _a.values, defaultValue = _a.defaultValue;
    var formatAttrs = function (_attrs) {
        var _a;
        var val = getNestedValue(_attrs[attrName], values);
        if (val === defaultValue)
            return false;
        return _a = {}, _a[attrName] = val, _a;
    };
    return { formatAttrs: formatAttrs, values: values, defaultValue: defaultValue };
};
/**
 * analysis of attrs for constructing typesetting
 * @param config ITypesetProps
 * @returns {number} defaultFontSize default font size, used to transform
 * @returns {Function} formatAttrs used to format and output `attrs` according to config
 * @returns {Object} defaultAttrs new default `attrs` constructed according to config
 */
var constructTypesetParseDOM = function (config) {
    var _a = config.defaultFontSize, defaultFontSize = _a === void 0 ? 16 : _a;
    var defaultAttrs = {};
    var getNestedValueByKey = {};
    var allowValues = {
        align: ['left', 'center', 'right', 'justify'],
    };
    Object.keys(config).forEach(function (key) {
        if (!/^allowed/.test(key) || !config[key])
            return;
        var attrName = getAttrName(key);
        var _a = formatAllowedValues(config[key]), values = _a.values, defaultValue = _a.defaultValue;
        defaultValue !== undefined && (defaultAttrs[attrName] = { default: defaultValue });
        values && (allowValues[attrName] = values);
        getNestedValueByKey[attrName] = function (val) { return getNestedValue(val, values); };
    });
    var formatAttrs = function (nodeAttrs, dom) {
        /**
         * * if not pass, do not accept all values (default behavior)
         * * pass [], accept all values
         * * other ['xx'] conditions are matched according to the configuration
         */
        var attrs = __assign({}, nodeAttrs);
        Object.keys(attrs).forEach(function (key) {
            var val = attrs[key];
            // not number, use match
            if (Number.isNaN(parseInt(val, 10))) {
                if (!allowValues[key]) {
                    attrs[key] = undefined;
                    return;
                }
                if (!allowValues[key].length)
                    return;
                var resVal = allowValues[key].includes(val) ? val : undefined;
                attrs[key] = resVal;
                return;
            }
            var formatFn = getNestedValueByKey[key];
            if (formatFn) {
                val !== undefined && val !== '' && (attrs[key] = formatFn(+val));
            }
            else {
                attrs[key] = undefined;
            }
        });
        return attrs;
    };
    return { defaultFontSize: defaultFontSize, formatAttrs: formatAttrs, defaultAttrs: defaultAttrs };
};
var formatMenuValues = function (attrsName, valueConfigs, defaultVal) {
    if (valueConfigs === void 0) { valueConfigs = []; }
    if (defaultVal === void 0) { defaultVal = false; }
    var res = [];
    if (!valueConfigs)
        return res;
    var values = valueConfigs;
    if (!Array.isArray(valueConfigs))
        values = [valueConfigs];
    values.forEach(function (val) {
        var _a, _b;
        if (typeof val === 'object') {
            var config = __assign({}, val);
            if (val.value !== undefined)
                config.text = val.value;
            if (!val.attrs)
                config.attrs = val.default ? defaultVal : (_a = {}, _a[attrsName] = val.value, _a);
            res.push(config);
        }
        else {
            res.push({ text: val, attrs: (_b = {}, _b[attrsName] = val, _b) });
        }
    });
    return res;
};
export { constructTypesetParseDOM, formatMenuValues, getFormatAttrsByValue, getNestedValue, };
//# sourceMappingURL=typeset.js.map